import { Component } from '@angular/core';

import { PowerbiReportComponent } from '@next/core-lib/powerbi-embedded';

import {
  DAIRYNEXT_REPORT_IDS,
  DAIRYNEXT_WORKSPACE_ID,
  SINGLE_PAGE_POWERBI_CONFIG,
} from '../shared/models/powerbi-config.model';

@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  imports: [PowerbiReportComponent],
})
export class HomepageComponent {
  public readonly workspaceId = DAIRYNEXT_WORKSPACE_ID;
  public readonly reportId = DAIRYNEXT_REPORT_IDS.HOMEPAGE;
  public readonly baseEmbedConfig = SINGLE_PAGE_POWERBI_CONFIG;
}
